import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, Image as ImageIcon, UploadCloud } from "lucide-react";
import { toast } from "sonner";

export default function Media() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    const { data } = await api.get("/api/admin/media");
    setItems(data); setBusy(false);
  };
  useEffect(() => { load(); }, []);

  const requestUpload = async () => {
    const { data } = await api.post("/api/admin/media/signed-upload-url", { filename: "demo.png", kind: "doc_asset" });
    toast.success(`Signed URL issued (mocked): ${data.url}`);
  };

  return (
    <div className="space-y-6" data-testid="media-page">
      <div className="flex items-center justify-between">
        <div className="text-[var(--text-2)] text-sm">
          Media stored on <span className="badge badge-warning">MOCKED</span> S3 + CloudFront. Production swap-in via <code className="font-mono">StorageService</code>.
        </div>
        <button onClick={requestUpload} className="btn-gold px-4 py-2 rounded text-sm flex items-center gap-2" data-testid="request-upload-btn">
          <UploadCloud size={14}/> Request signed URL
        </button>
      </div>

      <div className="card-surface p-12 text-center">
        {busy ? <Loader2 className="inline animate-spin" size={14}/> :
         items.length === 0 ? (
          <div className="text-[var(--text-3)]">
            <ImageIcon size={36} className="inline mb-3 opacity-50"/>
            <div>No assets uploaded yet. Use the signed upload URL endpoint to push assets to S3.</div>
          </div>
        ) : (
          <div className="grid grid-cols-4 gap-3">
            {items.map(m => (
              <div key={m.id} className="card-surface p-3">
                <div className="aspect-square bg-[var(--surface-3)] rounded mb-2"></div>
                <div className="text-xs font-mono truncate">{m.filename}</div>
                <div className="text-[10px] text-[var(--text-3)]">{m.kind}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
